// angular
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input } from '@angular/core';

// services
import { UtilityService } from '@app/core/utility/utility.service';
import { BaseService } from '@core/base/base.service';

// rxjs
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';

// wml-components
import { WMLConstructorDecorator, WMLImage, generateClassPrefix, generateIdPrefix } from '@windmillcode/wml-components-base';

// misc
import { ENV } from '@env/environment';
import { SpecificService } from '@core/specific/specific.service';
import { AccountsService } from '@shared/services/accounts/accounts.service';
import { NavService } from '@shared/services/nav/nav.service';

@Component({
    selector: 'logo-img-zero',
    templateUrl: './logo-img-zero.component.html',
    styleUrls: ['./logo-img-zero.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LogoImgZeroComponent {
  constructor(
    public cdref:ChangeDetectorRef,
    public specificService:SpecificService,
    public utilService:UtilityService,
    public baseService:BaseService,
    public accountsService:AccountsService,
    public navService:NavService,
  ) { }

  classPrefix = generateClassPrefix('LogoImgZero');
  idPrefix = generateIdPrefix(ENV.idPrefix.logoImgZero);

  @Input('props') props: LogoImgZeroProps = new LogoImgZeroProps();

  @HostBinding('class') myClass: string = this.classPrefix('View');
  @HostBinding('id') myId: string = this.idPrefix();

  ngUnsub = new Subject<void>();
  homeLocation = ENV.nav.urls.landing
  navToHome =(event: Event)=>{
    event.preventDefault();
    this.navService.mobileNavZero.close()
    this.navService.mobileNavOne.close()
    this.utilService.router.navigateByUrl(this.homeLocation)
  }

  listenForUser = ()=>{
    return this.accountsService.listenForUser({ngUnsub:this.ngUnsub})
    .pipe(
      takeUntil(this.ngUnsub),
      tap(()=>{
        let {currentUser}= this.accountsService
        if(currentUser){
          this.homeLocation = ENV.nav.urls.home
        }
      })
    )

  }

  ngOnInit(): void {
    this.listenForUser().subscribe()
  }

  ngOnDestroy() {
    this.ngUnsub.next();
    this.ngUnsub.complete();
  }
}

@WMLConstructorDecorator
export class LogoImgZeroProps {
  constructor(props: Partial<LogoImgZeroProps> = {}) {}
  backgroundImg:WMLImage
}
